import { Component, OnDestroy } from '@angular/core';
import {Router} from '@angular/router';
import {fromEvent} from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {routerTransition} from '../router.animations';
import { UserSettingsService } from '../shared/user-settings.service';


@Component({
    selector: 'dashboard-component',
    animations: [ routerTransition ],
    templateUrl: 'dashboard.component.html'
})
export class DashboardComponent implements OnDestroy {
    sizeClass = '';
    resizeSubscription;
    constructor(public userSettings: UserSettingsService, router: Router) {
        this.updateClass(window);
        this.resizeSubscription = fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe((event:any) => {
            this.updateClass(event.target);
        });
    }
    getState(outlet) {
        return outlet.activatedRouteData.state;
    }
    updateClass(elem) {
        let width = elem.innerWidth;
        if( width < 768 ) {
            this.sizeClass = 'mobile';
        }
        if( width >= 768 && width < 1030 ) {
            this.sizeClass = 'tablet';
        }
        if( width >= 1030 ) {
            this.sizeClass = 'desktop';
        }
    }
    ngOnDestroy() {
        if( this.resizeSubscription ) {
            this.resizeSubscription.unsubscribe();
        }
    }
}
